import { combineReducers } from 'redux';
import produce from 'immer';
import {
  ProcessScheduleActionType,
  ProcessScheduleAction,
  ProcessScheduleEditingDetails,
} from '../../actions/processScheduleActions';

const loading = (state = false, action: ProcessScheduleAction) => {
  switch (action.type) {
    case ProcessScheduleActionType.GET_PROCESS_SCHEDULES:
    case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES:
      return true;
    case ProcessScheduleActionType.GET_PROCESS_SCHEDULES_OK:
    case ProcessScheduleActionType.GET_PROCESS_SCHEDULES_ERROR:
    case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES_OK:
    case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ProcessScheduleAction) => {
  switch (action.type) {
    case ProcessScheduleActionType.GET_PROCESS_SCHEDULES:
    case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES:
      return '';
    case ProcessScheduleActionType.GET_PROCESS_SCHEDULES_ERROR:
    case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES_ERROR:
      return action.error;
    default:
      return state;
  }
};

const creating = (state = false, action: ProcessScheduleAction) => {
  switch (action.type) {
    case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE:
      return true;
    case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE_OK:
    case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE_ERROR:
      return false;
    default:
      return state;
  }
};

const createError = (state = '', action: ProcessScheduleAction) => {
  switch (action.type) {
    case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE:
      return '';
    case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE_ERROR:
      return action.error;
    default:
      return state;
  }
};

type DeletingState = { deleting: boolean; deleteError: string };
type EditingStates = {
  [editingStatusKey in ProcessScheduleEditingDetails['statusKey']]: boolean;
};
type EditingErrors = {
  [editingErrorKey in ProcessScheduleEditingDetails['errorKey']]: string;
};

export type ProcessScheduleState = DeletingState & EditingStates & EditingErrors;

interface ProcessScheduleStatesById {
  [id: string]: ProcessScheduleState;
}

const byId = (state: ProcessScheduleStatesById = {}, action: ProcessScheduleAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ProcessScheduleActionType.GET_PROCESS_SCHEDULES_OK: {
        action.data.forEach((schedule) => {
          draft[schedule.id] = {} as ProcessScheduleState;
        });

        break;
      }
      case ProcessScheduleActionType.LIST_WORKSPACE_SCHEDULES_OK: {
        action.data.forEach((schedule) => {
          draft[schedule.id] = {} as ProcessScheduleState;
        });

        break;
      }
      case ProcessScheduleActionType.EDIT_PROCESS_SCHEDULE: {
        draft[action.scheduleId][action.statusKey] = true;
        draft[action.scheduleId][action.errorKey] = '';
        break;
      }
      case ProcessScheduleActionType.EDIT_PROCESS_SCHEDULE_OK: {
        draft[action.scheduleId][action.statusKey] = false;
        break;
      }
      case ProcessScheduleActionType.EDIT_PROCESS_SCHEDULE_ERROR: {
        draft[action.scheduleId][action.statusKey] = false;
        draft[action.scheduleId][action.errorKey] = action.error;
        break;
      }
      case ProcessScheduleActionType.DELETE_PROCESS_SCHEDULE: {
        draft[action.scheduleId].deleting = true;
        draft[action.scheduleId].deleteError = '';
        break;
      }
      case ProcessScheduleActionType.DELETE_PROCESS_SCHEDULE_OK: {
        delete draft[action.scheduleId];
        break;
      }
      case ProcessScheduleActionType.DELETE_PROCESS_SCHEDULE_ERROR: {
        draft[action.scheduleId].deleting = false;
        draft[action.scheduleId].deleteError = action.error;
        break;
      }
      case ProcessScheduleActionType.CREATE_PROCESS_SCHEDULE_OK: {
        draft[action.data.id] = {} as ProcessScheduleState;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  loading,
  loadingError,
  creating,
  createError,
  byId,
});
